export default {
  title: 'Grazie per aver inviato le tue informazioni per ricevere i pagamenti',
  description:
    'La revisione da parte di Stripe potrebbe richiedere fino a 48 ore. Nel frattempo puoi proseguire con i passaggi successivi. Ti informeremo via e-mail non appena le tue informazioni saranno confermate.',
};
